import { PgFieldGridComponent } from './pg-field-grid.component';

export abstract class PgGridLayoutStrategy {
  protected abstract _reconcileRowTops();
  protected abstract _reconcileGridHeight();
  protected abstract _reconcileSubscriptPosition();
  protected abstract _setBorderRadii();

  public reconcileLayout() {
    if (
      this.componentRef.fieldRowChildren &&
      this.componentRef.fieldRowChildren.length
    ) {
      this._reconcileRowTops();
      this._reconcileGridHeight();
      this._reconcileSubscriptPosition();
      this._setBorderRadii();
    }
  }
  constructor(public componentRef: PgFieldGridComponent) {}
}

export class PgGridLargeViewportLayoutStrategy extends PgGridLayoutStrategy {
  constructor(componentRef: PgFieldGridComponent) {
    super(componentRef);
  }
  protected _reconcileRowTops() {
    this.componentRef.fieldRowChildren.forEach((r, i) =>
      this.componentRef.renderer.setStyle(r.hostElement, 'top', `-${i}px`)
    );
  }
  protected _reconcileGridHeight() {
    this.componentRef.renderer.setStyle(
      this.componentRef.gridWrapperEl,
      'height',
      null
    );
  }
  protected _reconcileSubscriptPosition() {
    const offset = this.componentRef.fieldRowChildren.length - 1;

    this.componentRef.renderer.setStyle(
      this.componentRef.subscriptWrapperEl,
      'top',
      `-${offset}px`
    );
  }

  protected _setBorderRadii() {
    this.componentRef.fieldRowChildren.forEach((fieldRow, index, array) => {
      if (index === 0) {
        fieldRow._componentChildren.forEach((f, i, a) => {
          this.componentRef.renderer.setStyle(
            f.fieldBorderEl,
            'border-radius',
            0
          );
          if (i === 0) {
            this.componentRef.renderer.setStyle(
              f.fieldBorderEl,
              'border-top-left-radius',
              '4px'
            );
          }
          if (i === a.length - 1) {
            this.componentRef.renderer.setStyle(
              f.fieldBorderEl,
              'border-top-right-radius',
              '4px'
            );
          }
        });
      } else if (index === array.length - 1) {
        fieldRow._componentChildren.forEach((f, i, a) => {
          this.componentRef.renderer.setStyle(
            f.fieldBorderEl,
            'border-radius',
            0
          );
          if (i === 0) {
            this.componentRef.renderer.setStyle(
              f.fieldBorderEl,
              'border-bottom-left-radius',
              '4px'
            );
          }
          if (i === a.length - 1) {
            this.componentRef.renderer.setStyle(
              f.fieldBorderEl,
              'border-bottom-right-radius',
              '4px'
            );
          }
        });
      } else {
        fieldRow._componentChildren.forEach(f => {
          this.componentRef.renderer.setStyle(
            f.fieldBorderEl,
            'border-radius',
            0
          );
        });
      }
    });
  }
}

export class PgGridSmallViewportLayoutStrategy extends PgGridLayoutStrategy {
  constructor(componentRef: PgFieldGridComponent) {
    super(componentRef);
  }
  protected _reconcileRowTops() {
    let accumulator = 0;
    this.componentRef.fieldRowChildren.forEach((cur, i, arr) => {
      if (i === 0) {
        this.componentRef.renderer.setStyle(cur.hostElement, 'top', `0px`);
      } else {
        const prev = arr[i - 1];
        this.componentRef.renderer.setStyle(
          cur.hostElement,
          'top',
          `${-prev._templateChildren.length - accumulator}px`
        );
        accumulator += prev._templateChildren.length;
      }
    });
  }
  protected _reconcileGridHeight() {
    // const offset = this.componentRef.fieldRowChildren.reduce(
    //   (acc, cur) => acc + cur._templateChildren.length,
    //   0
    // );

    this.componentRef.renderer.setStyle(
      this.componentRef.gridWrapperEl,
      'height',
      null
    );
    // setTimeout(() => {
    //   this.componentRef.renderer.setStyle(
    //     this.componentRef.gridWrapperEl,
    //     'height',
    //     //`${this.componentRef.gridWrapperEl.offsetHeight - offset}px`
    //     `calc(100% - ${offset}px)`
    //   );
    // }, 0);
  }
  protected _reconcileSubscriptPosition() {
    const offset = this.componentRef.fieldChildren.length - 1;
    this.componentRef.renderer.setStyle(
      this.componentRef.subscriptWrapperEl,
      'top',
      `-${offset}px`
    );
  }

  protected _setBorderRadii() {
    this.componentRef.fieldChildren.forEach((field, index, array) => {
      this.componentRef.renderer.setStyle(
        field.fieldBorderEl,
        'border-radius',
        0
      );
      if (index === 0) {
        this.componentRef.renderer.setStyle(
          field.fieldBorderEl,
          'border-radius',
          '4px 4px 0px 0px'
        );
      } else if (index === array.length - 1) {
        this.componentRef.renderer.setStyle(
          field.fieldBorderEl,
          'border-radius',
          '0px 0px 4px 4px'
        );
      }
    });
  }
}
